import "./LocalSeoConsultantBolton.module.css";
import Header from "@/reusable_sections/Header";
import Industries from "./sections/Industries";
import Services from "./sections/Services";
import Casestudyimpact from "./sections/Casestudyimpact";
import Localhero from "./sections/Localhero";
import Methodology from "./sections/Methodology";
import ConsultationCTA from "./sections/ConsultationCTA";
import Consultant from "./sections/Consultant";
import Localsearch from "./sections/Localsearch";
import Bolton from "./sections/Bolton";
import Localseofaq from "./sections/Localseofaq";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantBoltonPage() {
  return <div>
      <Header />
      <Industries />
      <Services />
      <Casestudyimpact />
      <Localhero />
      <Methodology />
      <ConsultationCTA />
      <Consultant />
      <Localsearch />
      <Bolton />
      <Localseofaq />
      <Footer />
    </div>;
}